var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5733 0.589543C8.28041 0.29665 7.80553 0.29665 7.51264 0.589543C7.21975 0.882436 7.21975 1.35731 7.51264 1.6502L12.0643 6.2019H0.957031C0.542818 6.2019 0.207031 6.53769 0.207031 6.9519C0.207031 7.36612 0.542818 7.7019 0.957031 7.7019H12.0652L7.51246 12.2577C7.21967 12.5507 7.21982 13.0256 7.51282 13.3184C7.80581 13.6112 8.28068 13.611 8.57348 13.318L14.4055 7.48206C14.4082 7.47935 14.4109 7.47663 14.4136 7.47389C14.6299 7.2508 14.6802 6.92652 14.5645 6.65637C14.5318 6.57986 14.4857 6.50768 14.4263 6.44338C14.4837 6.50556 14.5307 6.57748 14.5645 6.65637",
    fill: "black",
    className: "only-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5733 0.589543L14.4029 6.41919L8.5733 0.589543Z",
    fill: "black",
    className: "only-fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.26d7d422b860770d7c60da9b3628086e.svg";
export { ForwardRef as ReactComponent };